import React from "react";

interface Props {
  label: string;
  value: string | null | undefined;
}

const DescriptionView: React.FC<Props> = ({ label, value }) => {
  return (
    <div className="bg-[#FFF] p-3 rounded mt-1 w-full shadow shadow-neutral-400">
      <p className="font-medium font-[Poppins] text-sm text-[#E90101]">
        {label}
      </p>{" "}
      <p>{value}</p>
    </div>
  );
};

export default DescriptionView;
